import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { IPayout, IPayoutSummary } from '@curbnturf/entities';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'user/financial/payouts';

/** Payout requests (server AdminAuthGuard). Replaces @curbnturf/user-dashboard's FinancialService for admin. */
@Injectable({ providedIn: 'root' })
export class AdminPayoutApiService {
  private readonly http = inject(HttpClient);

  list(status?: string): Observable<IPayout[]> {
    return this.http.get<IPayout[]>(status ? `${API_URL}?status=${encodeURIComponent(status)}` : API_URL);
  }

  /** One user's payout requests, any status (`GET .../payouts/:userId`; admins may read anyone's). */
  forUser(userId: number): Observable<IPayout[]> {
    return this.http.get<IPayout[]>(`${API_URL}/${userId}`);
  }

  /** How many payouts have this status, and their requested total. */
  summary(status: string): Observable<IPayoutSummary> {
    return this.http.get<IPayoutSummary>(`${API_URL}/summary?status=${encodeURIComponent(status)}`);
  }

  /** Records the admin's response (paid/declined/pending); the server notifies the user. */
  complete(payout: IPayout): Observable<IPayout> {
    return this.http.put<IPayout>(`${API_URL}/${payout.id}`, payout);
  }
}
